/*
================================================================================

  CONTACT MODAL

================================================================================
*/

import $ from 'jquery';

const Modal = (() => {

	const init = function() {
		$(".js-modal-launch").click(function() {
			$(".js-modal").addClass("cta-modal--active")
		});
		$(".js-modal-close").click(function() {
			$(".js-modal").removeClass("cta-modal--active")
		});
	
	
		if ($(".errors")[0]){
			$(".js-modal").addClass("cta-modal--active")
		}
	};
	
	return {
		init: init
	};
	
})();

export default Modal;
